export interface IVehicle {
  vin: string
  vrm: string
  year: number
  make: string
  model: string
  color: string
  fuel_type: string
  selected: boolean
  date_first_registered: string
  registration_dates: string[]
  first_registered: string
  dpf_qualified?: boolean
  range: string
  series: string
  source: string
  cylinders: number
  euro_status: string
  selected_date: string
}

const now = new Date()

export function vehicleFactory(data?: IVehicle): IVehicle {
  return {
    vin: data?.vin || '',
    vrm: data?.vrm || '',
    year: data?.year || now.getFullYear(),
    make: data?.make || '',
    model: data?.model || '',
    color: data?.color || '',
    fuel_type: data?.fuel_type || '',
    selected: data?.selected || false,
    dpf_qualified: data?.dpf_qualified || false,
    date_first_registered: data?.date_first_registered || '',
    registration_dates: data?.registration_dates || [],
    first_registered: data?.first_registered || '',
    range: data?.range || '',
    series: data?.series || '',
    source: data?.source || '',
    cylinders: data?.cylinders || 0,
    euro_status: data?.euro_status || '',
    selected_date: data?.selected_date || '',
  }
}
